import React, { useState, useEffect }from 'react';
import { TailSpin } from  'react-loader-spinner'
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import Colors from '../../library/Colors';
import Button from '@mui/material/Button';

import 'react-toastify/dist/ReactToastify.css';

const LicenceLogoForm = (props) =>  {
    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState("");
    const [imageTicket, setImageTicket] = useState("");
    const [newImageSelected, setNewImageSelected] = useState(false);
    const [newTicketImageSelected, setNewTicketImageSelected] = useState(false);

    useEffect (()=>{
        try{
            SftGlobalData.post('client&action=fetchLogo', {key: props.api, user: props.username, sftUserId: props.userId}).then(response => {
                setImage(response.data);
                setLoading(false);
            });
            SftGlobalData.post('client&action=fetchLogoTicket', {key: props.api, user: props.username, sftUserId: props.userId}).then(response => {
                setImageTicket(response.data);
                setLoading(false);
            });
        } catch(e){
            console.error(e);
        }
    }, [props.api]);

    const onSave = async () => {
        // Only save if a new image was selected
        if (!newImageSelected) {
            console.log('No new image selected, skipping save');
            return;
        }
        
        try{
            let postData = {
                key: props.api,
                logo: image, 
                user: props.username, 
                sftUserId: props.userId
            }
            SftGlobalData.post('client&action=updateLogo', postData).then(response => {
                setNewImageSelected(false); // Reset after successful save
                // TODO: Notify success
            });
        } catch(e){
            console.error(e);
            // TODO: Error notify, bad request.
        }
    }

    const onSaveTicket = async () => {
        // Only save if a new ticket image was selected
        if (!newTicketImageSelected) {
            console.log('No new ticket image selected, skipping save');
            return;
        }
        
        try{
            let postData = {
                key: props.api,
                logo: imageTicket, 
                user: props.username, 
                sftUserId: props.userId
            }
            SftGlobalData.post('client&action=updateLogoTicket', postData).then(response => {
                setNewTicketImageSelected(false); // Reset after successful save
                // TODO: Notify success
            });
        } catch(e){
            console.error(e);
            // TODO: Error notify, bad request.
        }
    }

    function onFileChange(e) {
        let files = e.target.files;
        if (files && files[0]) {
            let fileReader = new FileReader();
            fileReader.readAsDataURL(files[0]);
     
            fileReader.onload = (event) => {
                setImage(event.target.result);
                setNewImageSelected(true); // Mark that a new image was selected
            }
        }
    }

    function onTicketFileChange(e) {
        let files = e.target.files;
        if (files && files[0]) {
            let fileReader = new FileReader();
            fileReader.readAsDataURL(files[0]);
     
            fileReader.onload = (event) => {
                setImageTicket(event.target.result);
                setNewTicketImageSelected(true); // Mark that a new ticket image was selected
            }
        }
    }

    return (
        <div className={props.theme + " _100perc"} style={{display:"flex", justifyContent: "space-evenly"}}>
            {loading && <div style={{display:"flex", justifyContent: "space-evenly", marginTop: 5}}>
                    <TailSpin 
                        height="40"
                        width="40"
                        color={Colors.sft_blue}
                        ariaLabel='loading'
                    />
                </div>}
            {!loading && <div className={props.theme + " _40perc"}>
                <p className={"primary_border_bottom text_center margin_top_none margin_bottom_15px bold "} style={{fontWeight: 1200}}>Logo</p>
                <div>
                    <div className='flex_center_column'>
                        <img alt="Logo" src={image} style={{width: 300, height: 100, objectFit: 'contain'}}/>
                    </div>
                    <br/>
                    <label className="text-white">Select File</label>
                    <input type="file" className="form-control" name="image" onChange={onFileChange} accept="image/*" />
                    <Button 
                        className={"modal_button_container_no_margin__button margin_top_15px _100perc"} 
                        onClick={()=>{onSave();}}
                        disabled={!newImageSelected}
                    >
                        {props.t('save')}
                    </Button>
                </div>
            </div>}

            {!loading && <div className={props.theme + " _40perc"}>
                <p className={"primary_border_bottom text_center margin_top_none margin_bottom_15px bold "} style={{fontWeight: 1200}}>Ticket logo</p>
                <div>
                    <div className='flex_center_column'>
                        <img alt="Ticket logo" src={imageTicket} style={{width: 300, height: 100, objectFit: 'contain'}}/>
                    </div>
                    <br/>
                    <label className="text-white">Select File</label>
                    <input type="file" className="form-control" name="image" onChange={onTicketFileChange} accept="image/*" />
                    <Button 
                        className={"modal_button_container_no_margin__button margin_top_15px _100perc"} 
                        onClick={()=>{onSaveTicket();}}
                        disabled={!newTicketImageSelected}
                    >
                        {props.t('save')}
                    </Button>
                </div>
            </div>}
        </div>
        
    );
}

export default LicenceLogoForm;